<template>
  <b-dropdown variant="success" :disabled="isDisabled">
    <template #button-content>
      <font-awesome-icon :icon="['fa-solid', 'fa-download']" size="1x" /> &nbsp;
    </template>
    <b-dropdown-item-button v-for="event in exportMethods" :key="event" @click="$emit(event)">
      {{ event.toUpperCase() }}
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
export default {
  name: 'ExportDropdown',
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    exportMethods() {
      return Object.keys(this.$listeners);
    }
  }
};
</script>
